export default "__VITE_ASSET__CUdk8Kz7__"